import { Button, Typography } from "@mui/material";
import React from "react";

const UpgradeBenefits = ({ onChange, value, loading, handleSubmit }) => {
    const handleChange = (e, index) => {
        const newBenefits = [...value];
        newBenefits[index] = e.target.value;
        onChange(newBenefits);
    };
  return (
    <div style={{ display: "block" }}>
      <Typography sx={{ marginTop: "10px", fontSize: "14px" }} variant="paragraph">
        Configure the Upgrade benefits that will appear on your upgrade plan page
      </Typography>
      <div style={{ width: "100%", marginTop: "10px" }}>
        <input
          type="text"
          placeholder="Add upgrade benefit here"
          value={value[0]}
          onChange={(e) => handleChange(e, 0)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div style={{ width: "100%", marginTop: "10px", marginTop:"16px" }}>
        <input
          type="text"
          placeholder="Add upgrade benefit here"
          value={value[1]}
          onChange={(e) => handleChange(e, 1)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div style={{ width: "100%", marginTop: "10px", marginTop:"16px" }}>
        <input
          type="text"
          placeholder="Add upgrade benefit here"
          value={value[2]}
          onChange={(e) => handleChange(e, 2)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>
      <div
        style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", width: "100%" }}
      >
        <Button
          onClick={handleSubmit}
          disabled={!value || loading}
          variant="contained"
          color="primary"
          sx={{ marginTop: "10px" }}
        >
          save
        </Button>
      </div>
    </div>
  );
};

export default UpgradeBenefits;
